import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap5';

import { useContext } from 'components/Managers/Dashboard/Context';
import CoveredStatistic from './CoveredStatistic';
import PaidStatistic from './PaidStatistic';
import AssignedStatistic from './AssignedStatistic';
import AvailableStatistic from './AvailableStatistic';
import InvitedStatistic from './InvitedStatistic';
import StartedStatistic from './StartedStatistic';
import AssessmentsStatistic from './AssessmentsStatistic';
import SessionsStatistic from './SessionsStatistic';

export default function Index({ policyEnabled }) {
  const { dispatch, actions, state: { filters, statistics } } = useContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    actions.loadStatistics(dispatch, filters, () => setLoading(false));
  }, [filters.policyPlanId, filters.teamId, filters.cycleId]);

  return (
    <section>
      <Row>
        <Col lg="6" className="mb-3 mb-lg-0">
          <h6 className="mb-3 fw-semibold">Policy</h6>

          <Row>
            {policyEnabled ? (
              <CoveredStatistic value={loading ? null : statistics.members_covered} />
            ) : (
              <PaidStatistic value={loading ? null : statistics.programs_paid} />
            )}

            <AssignedStatistic value={loading ? null : statistics.programs_assigned} />

            {policyEnabled ? (
              <AvailableStatistic value={loading ? null : statistics.programs_available} />
            ) : (
              <InvitedStatistic value={loading ? null : statistics.members_invited} />
            )}
          </Row>
        </Col>

        <Col lg="6">
          <h6 className="mb-3 fw-semibold">Programs</h6>

          <Row>
            <StartedStatistic value={loading ? null : statistics.programs_started} />

            <AssessmentsStatistic value={loading ? null : statistics.assessments_completed} />

            <SessionsStatistic value={loading ? null : statistics.sessions_completed} />
          </Row>
        </Col>
      </Row>
    </section>
  );
}

Index.propTypes = {
  policyEnabled: PropTypes.bool.isRequired,
};
